module.exports = __webpack_public_path__ + "media/images/ticket/view_cart-73441917df80de9ba3b3e5cf1e709e5a.png";